import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import UserListTable from "../../../components/userListTable";
import QUERY from "../../../utils/service/query";

// `?page=${p}&&userType=""&&status=""&&search=""&&order=""&&column=""&&limit="10"`
const UserList: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1");
  const limit = parseInt(searchParams.get("limit") || "10");
  const searchQuery = searchParams.get("search") || "";
  const statusQuery = searchParams.get("status") || "";
  const userTypeQuery = searchParams.get("userType") || "";
  const column = searchParams.get("column") || "createdOn";
  const order = searchParams.get("order") || "desc";

  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const [searchQuery1, setSearchQuery] = useState("");
  const [statusQuery1, setStatusQuery] = useState("");
  const [userTypeQuery1, setUserTypeQuery] = useState("");
  const [sortQuery, setSortQuery] = useState({
    column: "createdOn",
    order: "desc",
  });

  let variables: any = {
    page: page,
    limit: limit,
    searchQuery: searchQuery,
    userType: userTypeQuery,
    status: statusQuery,
    column: column,
    order: order,
  };
  Object.keys(variables).forEach(
    (k) => variables[k] === "" && delete variables[k],
  );
  const { data, loading, error } = useQuery(QUERY.USERS.GET_USERS, {
    fetchPolicy: "no-cache",
    variables: variables,
  });
  return (
    <>
      <Card className="">
        <Card.Header>
          <h5>User List</h5>
        </Card.Header>
        <Card.Body className="bg-light">
          {loading && (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
          {data?.usersList && (
            <UserListTable
              archived={false}
              data={data?.usersList || []}
              page={page}
              limit={limit}
              totalCount={data?.usersList?.totalCount || 1}
              searchQuery={searchQuery}
              userTypeQuery={userTypeQuery}
              statusQuery={statusQuery}
            />
          )}

          {error && <p>Something went wrong!</p>}
        </Card.Body>
      </Card>
    </>
  );
};

export default UserList;
